export default "__VITE_ASSET__B8y_nSuA__"